<p-fluid>
    <div class="grid grid-cols-1 lg:grid-cols-12 gap-6">
        <!-- ── Assignment controls ─────────────────────────────────────────── -->
        <div class="lg:col-span-5 flex flex-col gap-5">
            <div class="flex flex-col gap-1">
                <span class="font-semibold text-lg">Site Template</span>
                <small class="text-muted-color">
                    Pick which {{ categoryTypeLabel() }} template build serves this website. Manage templates and
                    publish versions under Websites → Site Templates.
                </small>
            </div>

            <!-- Current state -->
            <div class="flex flex-col gap-1">
                <span class="font-semibold">Currently serving</span>
                @if (currentTemplate(); as cur) {
                    <div class="flex items-center gap-2">
                        <span class="font-medium">{{ cur.Name }}</span>
                        @if (cur.CurrentVersion) {
                            <p-tag severity="success" [value]="'v' + cur.CurrentVersion" />
                        } @else {
                            <p-tag severity="danger" value="offline" pTooltip="Template has no published version — site serves 404" />
                        }
                    </div>
                } @else if (realm().SiteTemplateId) {
                    <span class="text-sm font-mono text-muted-color break-all">{{ realm().SiteTemplateId }}</span>
                } @else {
                    <span class="text-sm text-muted-color italic">Not assigned — the site is offline (404 / maintenance).</span>
                }
            </div>

            <!-- Assignment -->
            <div class="flex flex-col gap-1">
                <label for="siteTemplate" class="font-semibold">Assigned template</label>
                <p-select
                    inputId="siteTemplate"
                    [options]="options()"
                    optionLabel="label"
                    optionValue="value"
                    [ngModel]="selectedId()"
                    (ngModelChange)="selectedId.set($event)"
                    [showClear]="true"
                    placeholder="Not assigned (offline)"
                    appendTo="body"
                    [loading]="service.loading()"
                    [disabled]="saving()"
                />
                @if (options().length === 0 && !service.loading()) {
                    <small class="text-muted-color">No {{ categoryTypeLabel() }} templates exist yet. Create one under Site Templates first.</small>
                } @else {
                    <small class="text-muted-color">Only templates of this website's category type are listed. Clear the selection to take the site offline.</small>
                }
            </div>

            @if (dirty() && willGoOffline()) {
                <p-message severity="warn" styleClass="text-sm"
                    text="This change takes the site offline immediately — visitors get a 404 / maintenance page until a published template is assigned. There is no soft fallback." />
            } @else if (dirty()) {
                <p-message severity="warn" styleClass="text-sm"
                    text="Publishing this assignment switches the live site immediately." />
            }

            @if (error()) {
                <small class="text-red-500">{{ error() }}</small>
            }

            <div class="flex items-center gap-2">
                <p-button label="Apply" icon="pi pi-check" [loading]="saving()" [disabled]="!dirty()" (onClick)="apply()" />
                <p-button label="Reset" severity="secondary" outlined [disabled]="!dirty() || saving()" (onClick)="reset()" />
            </div>
        </div>

        <!-- ── Template Info ───────────────────────────────────────────────── -->
        <div class="lg:col-span-7">
            <div class="card flex flex-col gap-5 lg:sticky lg:top-20">
                <div>
                    <div class="font-semibold text-xl">Template Info</div>
                    <p class="text-sm text-muted-color m-0 mt-1">
                        What the selected template provides for AI branding (style, references, OG base, favicon).
                    </p>
                </div>

                <app-template-info
                    [brandKit]="brandKit()"
                    [loading]="brandKitLoading()"
                    [emptyMessage]="templateInfoEmpty()"
                />
            </div>
        </div>
    </div>
</p-fluid>
